
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.703 7.418l4.98 4.586-4.925 4.539-.211-.188-.04-8.734zm0 0","fill":"#fff"}}),_c('path',{attrs:{"d":"M8.465 12.207l-4.707 4.336 4.054 3.965 8.72-8.524L7.776 3.43 3.7 7.414l.004.004 4.762 4.387.219.199zm0 0","fill":"#504999"}}),_c('path',{attrs:{"d":"M3.547 16.355l-.04-8.734 4.763 4.383zm0 0","fill":"#c8c8c8"}}),_c('path',{attrs:{"d":"M7.469 13.121l-3.375 3.11 4.926-.95zm0 0","fill":"#38257a"}})])
          )
        }
      }
    